<template>
    <div>
        <div class="d-flex flex-wrap justify-content-between mr-3">
            <div class="px-4 fs-16 mt-3 fw-500 " style="color: #00448b;">
                <span class="highlighted"> Templates</span>
            </div>
            <div class="mb-3 mt-1">
                <button class="btn btn-create btn-smm " @click="addTemplate">
                    <i class="icon icon-plus-circle create-icon  fs-20"></i>
                    <span class="ml-1  fs-14 " style="color: #388e3c;"> New Template</span>
                </button>
            </div>
        </div>
        <div class="py-3 position-content-main" style="height: auto !important;">
            <div class="page-layout blank">
                <div class="pb-3" style="min-height:fit-content;">
                    <div class="d-flex flex-wrap justify-content-between" style="gap:1rem">
                        <div class="breadcrumbnewtheme pb-3">
                            <div class="pre gap-0p5 fw-500">
                                Templates
                            </div>
                            <!-- <span style="color:#b2bec3">/</span>
                            <div class="pre gap-0p5 fw-500 text-capitalize">
                                Templates
                            </div> -->
                            <span style="color:#b2bec3">/</span>
                            <span class="curr gap-0p5 fw-500">
                                List View
                            </span>
                        </div>
                        <div class="d-flex align-items-center justify-content-between mb-4" style="gap:.5rem">
                            <!-- <div class="hor-line"></div> -->
                            <button @click="firstPage()" :disabled="skip == 0" class="mt-1 pointer pagination-list">
                                <el-tooltip class="item" effect="dark" content="First Page" placement="top">
                                    <!-- <i class="icon-chevron-double-left"></i> -->
                            <img src="/static/images/new-theme2024/arrow-left.svg" style=" z-index: 10">
                                </el-tooltip>
                            </button>
                            <button @click="previousPage()" :disabled="skip == 0"
                                class="pagination-list-single mt-1 ml-2 pointer">
                                <el-tooltip class="item" effect="dark" content="Previous Page" placement="top">
                                    <!-- <i class="icon icon-chevron-left"></i> -->
                            <img src="/static/images/new-theme2024/arrow-left-single.svg" style=" z-index: 10">
                                </el-tooltip>
                            </button>
                            <span class="px-2 fw-500 fs-14 mt-1">Showing {{getSkipCount}} -
                                {{total>skip+limit?skip+limit:total}} of {{total}}</span>
                            <button @click="nextPage()" :disabled="skip_temp >= total"
                                class="pagination-list-single mt-1 mr-2 pointer">
                                <el-tooltip class="item" effect="dark" content="Next Page" placement="top">
                                    <!-- <i class="icon icon-chevron-right"></i> -->
                            <img src="/static/images/new-theme2024/arrow-right-single.svg" style=" z-index: 10">

                                </el-tooltip>
                            </button>
                            <button @click="lastPage()" class="mt-1 pointer pagination-list"
                                :disabled="temp_total+10 >= total">
                                <el-tooltip class="item" effect="dark" content="Last Page" placement="top">
                                    <!-- <i class="icon-chevron-double-right"></i> -->
                            <img src="/static/images/new-theme2024/arrow-right.svg" style=" z-index: 10">
                                </el-tooltip>
                            </button>
                        </div>
                    </div>
                    <div class="vendor-list height-fit-content" style="background-color: #f6f8fc !important;">
                        <div class="row" style="background: #f0ddb7;">
                            <div class="col-lg-4 col-md-4 col-sm-6 left-list" style="margin-right: -10px;">
                                <div class="mb-3 scroll-new view-box">
                                    <div v-if="ajax_call_in_progress" class="d-flex align-items-center justify-content-center h-100 bg-white" style="height: 100vh !important;">
                                        <img src="/static/images/new-theme2024/20 card.gif" width="100" alt="">
                                    </div>
                                    <div v-else v-for="(data, index) in list_data" :key="index">
                                        <div class="list-box px-4 py-2 pointer" :class="{ 'list-light': index % 2, 'highlight': template_id == data._id }" @click="getTemplateDataById(data, index)">
                                            <div class="d-flex flex-wrap justify-content-between">
                                                <span class="fs-14 font-weight-bold text-black" style="width: 275px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">Template Name:{{ data.name || "-" }}</span>
                                            </div>
                                            <div class="d-flex flex-wrap justify-content-between mt-2">
                                                <span class="text-black fw-600" style="width: 175px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;" :title="data.template_type">Template Type: {{ data.template_type || "-"}}</span>
                                                <span class="text-black fw-500 hide-line":title="data.creation_date">{{data.creation_date || "-"}}</span>
                                            </div>
                                            <div class="d-flex justify-content-between mt-2">
                                                <span class="text-black fw-500 "
                                                    style="width: 175px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis; "
                                                    :title="data.number_of_approves">Approver:
                                                    {{ data.number_of_approves || "0"}}</span>
                                                <span class="text-black fw-500 hide-line"
                                                    style="width: 175px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;"
                                                    :title="data.created_by">Creator:
                                                    {{data.created_by || "-"}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-8 col-md-8 col-sm-6 details-view-box scroll-new">
                                <div class="page-layout blank  pt-3" style="margin-left: 0px !important;margin-right: 0px !important;">
                                    <div class="pb-10">
                                        <div class="vendor-list br-t-l-r mt-2">
                                            <div class="mb-3">
                                                <div class=" d-flex align-items-center justify-content-between  ">
                                                    <PreviewTemplate :template_id="template_id" :can_edit="can_edit" @fetchListData="fetchListData" :list_loader="ajax_call_in_progress"></PreviewTemplate>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
            <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
            <create-template-popup style="z-index:999999 !important" v-if="show_add_template"
                @closeCreateTemplate="closeCreateTemplate" :mode="mode" @reload_template_id="reloadTemplateId"
                :selected_template_id="selected_template_id" modal_name="CreateTemplatePopup">
            </create-template-popup>
        </div>
    </div>
</template>
<script>
    import {
        SweetModal
    } from 'sweet-modal-vue';
    import dynamic_template from '../../mixins/dynamic_template'
    const CreateTemplatePopup = () => import('./CreateTemplatePopup')
    const PreviewTemplate = () => import('./PreviewTemplate')
    import {EventBus} from '../../eventBus/nav-bar-event'

    import Swal from 'sweetalert2';
    // import PreviewTemplate from './PreviewTemplate.vue';
    export default {
        mixins: [dynamic_template],
        components: {
            SweetModal,
            CreateTemplatePopup,
            PreviewTemplate,
            Swal
        },
        data() {
            return {
                delete_loader: false,
                success_msg: '',
                warning_msg: '',
                list_data: [],
                ajax_call_in_progress: false,
                skip: 0,
                limit: 10,
                total: 0,
                temp_total: 0,
                search_key: '',
                pageLimit: [],
                skip_temp: 0,
                count: 0,
                passed_key: {
                    key: 'created_date',
                    value: -1
                },
                show_add_template: false,
                selected_template_id: '',
                template_id: '',
                mode: 'create',
                pageLimit: [],
                curr_page: 1,
                lastPageClicked: false,
                total_pages: 0,
                status_based_total: 0,
                can_edit:false,
            }
        },
        methods: {
            searchData() {
                this.fetchListData()
            },
            goToViewPage(id) {
                this.$router.push('/dynamictemplate/view/' + id);
            },
            async getTemplateDataById(data, index) {
                this.template_id = data._id
                this.can_edit=data.can_edit
            },
            // async templateDetails(data, index){
            //     this.list_id_index = index
            //     try{
            //         this.load_details = true
            //         let params = {
            //             id: data.id
            //         }

            //         let response = await this.viewLeavesForEmployees(params)
            //         if(response.status_id == 1){
            //             this.view_leave = response.response
            //             this.author_details = this.view_leave.author_details
            //             this.leave_type = this.view_leave.leave_type
            //             this.view_leave.from_date = this.view_leave.from_date
            //             this.view_leave.to_date = this.view_leave.to_date
            //             this.no_of_days = this.view_leave.no_of_days
            //             this.balance_leaves = this.view_leave.balance_leaves
            //             this.hr_details.show_details = this.view_leave.hasOwnProperty('approve_details')
            //             if(this.hr_details.show_details){
            //                 this.hr_details.data = this.view_leave.approve_details
            //                 this.hr_details.note = this.view_leave.action_log.note
            //             }
            //         }
            //         this.load_details = false
            //     } catch(err){
            //         this.load_details = false
            //     }
            // },
            previewTemplate(id) {
                this.$router.push('/dynamictemplate/preview/' + id);
            },
            setPasskey: function (newKey) {
                this.$set(this.passed_key, 'key', newKey)
                var value = this.passed_key.value == -1 ? 1 : -1
                this.$set(this.passed_key, 'value', value)
                // this.searchData()
                this.fetchListData()
            },
            // firstPage() {
            //     this.temp_total = 0
            //     this.skip = 0
            //     this.limit = 10
            //     this.skip_temp = 0
            //     this.list_data = []
            //     this.fetchListData()
            // },
            // lastPage() {
            //     this.skip_temp = 0
            //     this.skip = 0
            //     this.temp_total = this.total
            //     let no_of_pages = Math.ceil(this.total / this.limit)
            //     this.skip_temp = (no_of_pages * this.limit) - this.limit
            //     if (this.skip_temp >= this.total) {
            //         return;
            //     }
            //     this.skip = this.skip_temp
            //     this.fetchListData();
            // },
            // nextPage() {
            //     this.skip_temp = this.skip + this.limit > this.total ? this.total : this.skip + this.limit;
            //     this.temp_total = this.skip_temp;
            //     if (this.skip_temp >= this.total) {
            //         return;
            //     }
            //     this.skip = this.skip_temp;
            //     this.curr_page = Math.ceil(this.skip / this.limit) + 1;
            //     this.fetchListData();
            // },
            // previousPage() {
            //     this.temp_total = 0;
            //     this.skip_temp = 0;
            //     if (this.skip == 0) {
            //         return;
            //     }
            //     this.skip = this.skip - this.limit <= 0 ? 0 : this.skip - this.limit;
            //     this.curr_page = Math.ceil(this.skip / this.limit) + 1;
            //     this.fetchListData();
            // },

            // createPagination(page) {
            //     if (page === this.curr_page) {
            //         return;
            //     }
            //     this.curr_page = page;
            //     this.skip = (page - 1) * this.limit;
            //     this.fetchListData();
            // },
            firstPage() {
                this.temp_total = 0
                this.skip = 0
                this.limit = 10
                this.list_data = []
                this.fetchListData()
            },
            lastPage() {
                this.skip_temp = 0
                this.skip = 0
                this.temp_total = this.total
                let no_of_pages = Math.ceil(this.total / this.limit)
                this.skip_temp = (no_of_pages * this.limit) - this.limit
                if (this.skip_temp >= this.total) {
                    return;
                }
                this.skip = this.skip_temp
                this.fetchListData();
            },
            nextPage() {
                this.skip_temp = this.skip + this.limit > this.total ? this.total : this.skip + this.limit;
                if (this.skip_temp >= this.total) {
                    return;
                }
                this.skip = this.skip_temp;
                this.fetchListData();
            },
            previousPage() {
                this.skip_temp = 0
                this.temp_total = 0
                if (this.skip == 0) {
                    return;
                }
                this.skip = this.skip - this.limit <= 0 ? 0 : this.skip - this.limit;
                this.fetchListData();
            },
            addTemplate() {
                if (localStorage.getItem('storedTemplateData')) {
                    localStorage.removeItem('storedTemplateData')
                }
                this.mode = 'create'
                this.selected_template_id = ''
                this.show_add_template = true
                EventBus.$emit('ZindexChangeStart')
                setTimeout(() => {
                    this.$modal.show('CreateTemplatePopup')
                }, 500);
            },
            reloadTemplateId(id) {
                this.selected_template_id = id
            },
            closeCreateTemplate() {
                EventBus.$emit('ZindexChangeEnd')
                this.show_add_template = false
            },
            editTemplate(id) {
                EventBus.$emit('ZindexChangeStart')
                if (localStorage.getItem('storedTemplateData')) {
                    localStorage.removeItem('storedTemplateData')
                }
                this.mode = 'edit'
                this.selected_template_id = id
                this.show_add_template = true
                setTimeout(() => {
                    this.$modal.show('CreateTemplatePopup')
                }, 1000);
            },
            deleteTemplateConfirm(id) {
                Swal.fire({
                    title: 'Alert',
                    text: "Are you sure want to delete ?",
                    type: 'warning',
                    icon: 'warning',
                    showCloseButton: true,
                    showCancelButton: true,
                    confirmButtonColor: '#00448b',
                    confirmButtonText: 'YES',
                    cancelButtonText: 'NO'
                }).then((result) => {
                    if (result.isConfirmed == true) {
                        this.deleteTemplate(id)
                    }
                })
            },
            async deleteTemplate(id) {
                this.delete_loader = true
                try {
                    let params = {
                        dynamic_template_id: id
                    };
                    let response = await this.deleteDynamicTemplate(params);
                    this.success_msg = response.response
                    EventBus.$emit('ZindexChangeStart')
                    this.$refs.success_modal.open();
                    setTimeout(() => {
                        this.delete_loader = false
                        EventBus.$emit('ZindexChangeEnd')
                        this.$refs.success_modal.close();
                        this.fetchListData();
                    }, 3000);
                } catch (error) {
                    this.delete_loader = false
                    this.warning_msg = error;
                    EventBus.$emit('ZindexChangeStart')
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        EventBus.$emit('ZindexChangeEnd')
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            },
            async fetchListData() {
                this.list_data = [];
                this.status_based_total = 0
                this.total_pages = parseInt(this.status_based_total / this.limit)
                this.ajax_call_in_progress = true
                try {
                    let params = {
                        limit: this.limit,
                        search_key: this.search_key,
                        skip: this.skip,
                        sort_key: this.passed_key.key,
                        sort_value: this.passed_key.value
                    };
                    let response = await this.listDynamicTemplate(params);
                    this.list_data = response.response.dynamic_details
                    this.getTemplateDataById(this.list_data[0],0)
                    this.template_id = this.list_data[0]._id
                    this.list_data.forEach((e) => {
                        if (e.hasOwnProperty('template_type') && e.template_type.split('-').length == 2) {
                            e.template_type = e.template_type.replace('-', ' ')
                        }
                        if (e.hasOwnProperty('template_type') && e.template_type.split('_').length == 2) {
                            e.template_type = e.template_type.replace('_', ' ')
                        }
                    })
                    this.total = response.response.count;
                    this.total_pages = parseInt(response.response.count / this.limit)
                    this.status_based_total = response.response.count
                    this.ajax_call_in_progress = false
                } catch (error) {
                    console.log(error)
                    this.ajax_call_in_progress = false
                }
            }
        },
        mounted() {
            for (let i = 10; i <= 50; i += 10) {
                this.pageLimit.push(i);
            }
            if (this.$route.query.call_type == 'redirection_mode') {
                if (localStorage.getItem('storedTemplateData')) {
                    let temp_template_data = JSON.parse(localStorage.getItem('storedTemplateData'))
                    this.mode = temp_template_data.mode
                } else {
                    this.mode = 'create'
                }
                this.selected_template_id = ''
                this.show_add_template = true
                setTimeout(() => {
                    this.$modal.show('CreateTemplatePopup')
                    EventBus.$emit('ZindexChangeStart')
                }, 500);
            } else {
                localStorage.removeItem('storedTemplateData')
            }
            this.fetchListData();
        },
        watch: {
            limit: function () {
                this.fetchListData();
            }
        },
        computed: {
            getSkipCount() {
                if (this.total == 0) {
                    return 0
                } else {
                    let skip_count = this.skip > this.total ? this.total : this.skip + 1;
                    return skip_count;
                }
            },
        }
    }
</script>
<style scoped>
    .list-light {
        width: 100%;
        object-fit: contain;
        border-radius: 5px;
        box-shadow: 0 1.5px 3px 0 rgba(0, 0, 0, 0.16);
        border: solid 0.5px #f3f6fb;
        background-color: #ffffff;
    }
    .highlight {
        background-color: #d5e2fa !important;
    }

    @media (max-width: 1100px) {
        .hide-line {
            display: none;
        }
    }

    .edit-button {
        background-color: #fff;
        height: 32px !important;
        width: 40px;
        line-height: 32px !important;
        border-radius: 4px;
    }

    .box-blue-header {
        border-radius: 3px;
    }

    .box-blue-header-parent {
        background: #005dae;
        position: relative;
        top: -1px;
        margin-left: -1px;
    }

    .ticket_count {
        background-color: #7b7f97;
        border-radius: 20px;
        font-size: 10px;
        font-weight: 600 !important;
        color: #ffffff;
        margin-left: 4px;
        padding: 0px 6px;
    }

    .count-ticket {
        background-color: #1b57ad;
        border-radius: 20px;
        font-size: 10px;
        font-weight: 600 !important;
        color: #ffffff;
        margin-left: 4px;
        padding: 0px 6px;
    }

    .ticket_tab {
        background-color: #005dae;
    }

    .activeColor {
        background-color: #005dae;
        color: #ffffff;
    }

    .email-buttons {
        display: none;
    }

    @media screen and (max-width: 991px) {
        .mob-list-scroll {
            min-width: 991px;
        }
    }

    .btn-success {
        background-color: #25bb83 !important;
    }

    .ticket-list-button {
        color: #363636;
        border-radius: 6px !important;
        box-shadow: none !important;
        font-weight: 600;
        background-color: #e4e4e4;
        width: 230px;
    }
    .view-box {
        border: 1px solid #a5a5a5;
        border-radius: 6px
    }

    .scm-filters {
        font-family: "Poppins", "Helvetica Neue", sans-serif !important;
        height: 500px;
        overflow: auto;
        max-width: 768px;
        top: 100px;
        background: #e6ecff !important;
    }

    .overflow-visible {
        overflow: scroll !important;
    }
    .col-small-left {
        width: 200px;
    }

    .col-small-right {
        position: relative;
        width: 700px;
    }

    .left-list {
        height: max-content !important;
    }

    @media (max-width: 900px) {
        .scroll-news {
            min-width: 900px;
            overflow-x: scroll !important;
        }
    }

    @media (max-width: 580px) {
        .vendor-list {
            height: 100% !important;
        }
    }

    .hor-line {
        width: 2px;
        height: 30px;
        background-color: #1b57ad;
    }

    .filter-box {
        width: 200px;
        height: 30px;
        padding: 2px 3.3px 1.5px 6.5px;
        border: solid 0.5px #363636;
        background-color: #fff;
    }

    .width-fit-content {
        width: fit-content
    }

    .fs-18 {
        font-size: 18px;
    }

    .whitespace-nowrap {
        white-space: nowrap;
    }

    .dropbtn {
        background-color: #fff;
        cursor: pointer;
        margin-top: -5px;
        border-radius: 5px;
        line-height: 33px;
    }

    .res-width {
        min-width: 60%
    }

    .ticket_list_number-selected {
        background-color: #00448b !important;
        color: #fff !important;
    }

    .ticket_list_number-selected .li_span {
        color: #fff !important
    }

    .ticket_list_number-selected i {
        color: #fff !important;
        border: 1px solid #fff !important;
    }

    .ticket_list_number-selected i.no-border {
        border: none !important;
    }

    @media screen and (max-width:1347px) {
        .res-width {
            min-width: 75%
        }
    }

    @media screen and (max-width:1011px) {
        .res-width {
            min-width: 100%;
            flex-wrap: wrap
        }
    }


    .dropdown {
        position: relative;
        display: inline-block;
    }

    .dropdown-content {
        display: none;
        position: absolute;
        background-color: #fff;
        box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
        border-radius: 5px;
        z-index: 1;
        right: 0px;
        top: 32px;
    }

    .dropdown-content a {
        color: black;
        padding: 12px 16px;
        text-decoration: none;
        display: block;
    }

    .dropdown-content a:not([href]):not([tabindex]).tabbed {
        width: 100%;
        vertical-align: middle;
    }

    .dropdown-content a:not([href]):not([tabindex]).tabbed:hover {
        background-color: #eee;
    }

    .dropdown:hover .dropdown-content {
        display: block;
    }

    .height-fit-content {
        height: fit-content
    }
    .search_input {
        padding: 8px 9.4px 6.5px 33.4px;
        border-radius: 24px;
        background-color: #fff;
        border: 1px solid rgba(103, 103, 103, 0.84);
        border-radius: 18px;
    }

    .align-position {
        position: absolute;
        left: 10px;
        top: 7px;
        color: rgba(103, 103, 103, 0.84);
    }

    .search-bar {
        margin: 0 30px 0 30px;
    }

    .add-btn {
        margin-right: 24px;
        height: 34px;
    }

    .ht-100px {
        height: 100px;
    }

    .w-15 {
        width: 15% !important
    }

    .w-1 {
        width: 1% !important;
        min-width: 250px !important
    }

    .table-content-data tr th {
        text-transform: capitalize;
        color: #00448b;
        background-color: #e8e9ec;
    }

    .text-white {
        color: #fff !important;
    }

    .text-green {
        color: #038b62 !important;
    }

    .breadcrumbnewtheme {
        display: flex;
        align-items: center;
        gap: 1rem;
    }

    .breadcrumbnewtheme div {
        color: #00448b;
    }
    .fs-2rem {
        font-size: 2rem;
    }

    .position-content-main {
        border-radius: 14px;
        background-color: #f0ddb7;
    }

    .header-color {
        color: #4e4e4e !important;
    }
</style>